import React, { ReactNode } from 'react'
import { useInView } from '../../hooks/useInView'
import { usePrinting } from '../../hooks/usePrinting'
import { prefersReducedMotion } from '../../utils'
import styles from './charts.module.sass'

type Props = {
  height: number
  // What the chart shows, for screen readers. The numbers are in About this data.
  label: string
  // Renders the chart; animate is false under reduced motion and when printing.
  children: (animate: boolean) => ReactNode
}

// Holds the chart's space and mounts it the first time it scrolls into view,
// so Chart.js's own draw-in plays on screen.
export const ChartBox = ({ height, label, children }: Props) => {
  const [ref, inView] = useInView<HTMLDivElement>()
  const printing = usePrinting()
  const chart = inView || printing ? children(!printing && !prefersReducedMotion()) : null

  return (
    <div ref={ref} className={styles.box} style={{ height }} role="img" aria-label={label}>
      {chart}
    </div>
  )
}
